import { pipe } from "fp-ts/lib/function";
import { array, option } from "fp-ts";

export function arrayOfMaxLength3<T>(arr: Array<NonNullable<T>>): Array<NonNullable<T>> {
  return pipe(
    [...arr].slice(0, 3),
    array.filterMap(a => option.fromNullable(a)),
  );
}
